export const MARKET_INDICATORS_CONFIGS = {
    INDICES_ACTIONS: {
        mini_chart: [
            {
                index: "CAC40",
                src: "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js",
                script: {
                    "symbol": "INDEX:CAC40",
                    "width": "100%",
                    "locale": "fr",
                    "dateRange": "12m",
                    "colorTheme": "light",
                    "trendLineColor": "rgba(255, 0, 0, 1)",
                    "underLineColor": "rgba(244, 204, 204, 1)",
                    "isTransparent": false,
                    "autosize": false,
                    "largeChartUrl": ""
                },
            },
            {
                index: "SX5E",
                src: "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js",
                script: {
                    "symbol": "INDEX:SX5E",
                    "width": "100%",
                    "locale": "fr",
                    "dateRange": "12m",
                    "colorTheme": "light",
                    "trendLineColor": "rgba(255, 0, 0, 1)",
                    "underLineColor": "rgba(244, 204, 204, 1)",
                    "isTransparent": false,
                    "autosize": false,
                    "largeChartUrl": ""
                }
            },
            {
                index: "OANDA",
                src: "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js",
                script: {
                    "symbol": "OANDA:SPX500USD",
                    "width": "100%",
                    "locale": "fr",
                    "dateRange": "12m",
                    "colorTheme": "light",
                    "trendLineColor": "rgba(255, 0, 0, 1)",
                    "underLineColor": "rgba(244, 204, 204, 1)",
                    "isTransparent": false,
                    "autosize": false,
                    "largeChartUrl": ""
                }
            }
        ],
        index_table: [{
            index: "table-indices-actions",
            src: "https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js",
            script: {
                "title": "Indices",
                "locale": "fr",
                "width": "100%",
                "height": 740,
                "symbolsGroups": [
                    {
                    "name": "Europe",
                    "symbols": [
                        {
                        "name": "INDEX:CAC40",
                        "displayName": "CAC 40"
                        },
                        {
                        "name": "INDEX:SX5E",
                        "displayName": "Euro Stoxx 50"
                        },
                        {
                        "name": "FOREXCOM:UKXGBP",
                        "displayName": "FTSE 100 (UK)"
                        },
                        {
                        "name": "INDEX:DEU30",
                        "displayName": "DAX (DE)"
                        }
                    ]
                    },
                    {
                    "name": "Etats-Unis",
                    "symbols": [
                        {
                        "name": "FOREXCOM:DJI",
                        "displayName": "Dow Jones"
                        },
                        {
                        "name": "OANDA:SPX500USD",
                        "displayName": "S&P 500"
                        },
                    {
                        "name": "OANDA:NAS100USD",
                        "displayName": "Nasdaq 100"
                        }
                    ]
                    },
                    {
                    "name": "Asie",
                    "symbols": [
                        {
                        "name": "INDEX:NKY",
                        "displayName": "Nikkei 225 (JP)"
                        },
                        {
                        "name": "INDEX:HSI",
                        "displayName": "Hang Seng (HK)"
                        },
                        {
                        "name": "INDEX:KSIC",
                        "displayName": "KOSPI (KR)"
                        }
                    ]
                    }
                ],
                "colorTheme": "light"
            }
        }]
    },
    CHANGE_SPOT: {
        mini_chart: [
            {
                index: "EURUSD",
                src: "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js",
                script: {
                    "symbol": "FX_IDC:EURUSD",
                    "width": "100%",
                    "locale": "fr",
                    "dateRange": "12m",
                    "colorTheme": "light",
                    "trendLineColor": "rgba(255, 0, 0, 1)",
                    "underLineColor": "rgba(244, 204, 204, 1)",
                    "isTransparent": false,
                    "autosize": false,
                    "largeChartUrl": ""
                }
            },
            {
                index: "EURGBP",
                src: "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js",
                script: {
                    "symbol": "FX_IDC:EURGBP",
                    "width": "100%",
                    "locale": "fr",
                    "dateRange": "12m",
                    "colorTheme": "light",
                    "trendLineColor": "rgba(255, 0, 0, 1)",
                    "underLineColor": "rgba(244, 204, 204, 1)",
                    "isTransparent": false,
                    "autosize": false,
                    "largeChartUrl": ""
                }
            },
            {
                index: "EURJPY",
                src: "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js",
                script: {
                    "symbol": "FX_IDC:EURJPY",
                    "width": "100%",
                    "locale": "fr",
                    "dateRange": "12m",
                    "colorTheme": "light",
                    "trendLineColor": "rgba(255, 0, 0, 1)",
                    "underLineColor": "rgba(244, 204, 204, 1)",
                    "isTransparent": false,
                    "autosize": false,
                    "largeChartUrl": ""
                }
            }
        ],
        index_table: [{
            index: "table-change-spot",
            src: "https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js",
            script: {
                "title": "Devises",
                "title_link": "/markets/currencies/rates-major/",
                "locale": "fr",
                "width": "100%",
                "height": 1000,
                "symbolsGroups": [
                    {
                    "name": "Princpales",
                    "symbols": [
                        {
                        "name": "FX_IDC:EURUSD",
                        "displayName": "EUR/USD"
                        },
                        {
                        "name": "FX_IDC:EURGBP",
                        "displayName": "EUR/GBP"
                        },
                        {
                        "name": "FX_IDC:EURJPY",
                        "displayName": "EUR/JPY"
                        }
                    ]
                    },
                    {
                    "name": "Secondaires",
                    "symbols": [
                        {
                        "name": "FX_IDC:EURCHF",
                        "displayName": "EUR/CHF"
                        },
                        {
                        "name": "FX_IDC:EURCAD",
                        "displayName": "EUR/CAD"
                        },
                        {
                        "name": "FX_IDC:EURNOK",
                        "displayName": "EUR/NOK"
                        },
                        {
                        "name": "FX_IDC:EURCNH",
                        "displayName": "EUR/CNH"
                        },
                        {
                        "name": "FX_IDC:EURPLN",
                        "displayName": "EUR/PLN"
                        },
                        {
                        "name": "FX_IDC:EURAUD",
                        "displayName": "EUR/AUD"
                        },
                        {
                        "name": "FX_IDC:EURNZD",
                        "displayName": "EUR/NZD"
                        },
                        {
                        "name": "FX_IDC:EURCZK",
                        "displayName": "EUR/CZK"
                        },
                        {
                        "name": "FX_IDC:EURHUF",
                        "displayName": "EUR/HUF"
                        },
                        {
                        "name": "FX_IDC:EURDKK",
                        "displayName": "EUR/DKK"
                        },
                        {
                        "name": "FX_IDC:EURSEK",
                        "displayName": "EUR/SEK"
                        },
                        {
                        "name": "FX_IDC:EURSGD",
                        "displayName": "EUR/SGD"
                        },
                        {
                        "name": "FX_IDC:EURHKD",
                        "displayName": "EUR/HKD"
                        },
                        {
                        "name": "FX_IDC:EURZAR",
                        "displayName": "EUR/ZAR"
                        },
                        {
                        "name": "FX_IDC:EURMAD",
                        "displayName": "EUR/MAD"
                        }
                    ]
                    }
                ],
                "colorTheme": "light"
            }
        }]
    }
};

export const DASHBOARD_INDEX_CONFIG = {
    index: "dashboard-index",
    src: "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js",
    script: {
        "symbols": [
            {
                "description": "EURO STOXX 50",
                "proName": "INDEX:SX5E"
            },
            {
                "description": "CAC 40",
                "proName": "INDEX:CAC40"
            },
            {
                "description": "EUR/USD",
                "proName": "FX_IDC:EURUSD"
            },
            {
                "description": "EUR/GBP",
                "proName": "FX_IDC:EURGBP"
            },
            {
                "description": "EUR/JPY",
                "proName": "FX_IDC:EURJPY"
            }
        ],
        "colorTheme": "light",
        "isTransparent": false,
        "displayMode": "adaptive",
        "locale": "fr"
    }
}



// WEBPACK FOOTER //
// ./src/page/Consumer/MarketIndicators/IndexConfigs.tsx